import React from "react";
import { useSelector } from "react-redux";
import {Heading, SubHeading, Paragraph,} from "./BlockParts/index";

export default function BlurbBlock({ options, items, idx }) {
  const FontSettings = useSelector((state) => state.project?.fontStyle);
  return (
    <div key={idx} id={"block_" + idx} className="text-[18px] w-full flex flex-col justify-center p-1">
      <Heading options={options} fontStyle={FontSettings?.heading} idx={idx} />
      <SubHeading options={options} fontStyle={FontSettings?.subHeading} idx={idx}/>
      <Paragraph options={options} fontStyle={FontSettings?.blurb} items={items} idx={idx}/>
    </div>
  );
}